<template>
    <looping-rhombuses-spinner class="mx-auto"
        :size="60"
        color="#007bff"
    />
</template>

<script>
import {LoopingRhombusesSpinner} from 'epic-spinners';
export default {
    name: 'spinner',
    components: {
        LoopingRhombusesSpinner
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue